//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"FrontInnerLength",0,"Expression",0],[1,"FrontInnerOffset",0,"Expression",0],[1,"FrontOuterOffset",0,"Expression",0],[1,"FrontSelector",0,"ScCollector",0],[0,"InnerLineType",1,0],[0,"Loading",1,0],[0,"Position",1,0],[1,"RearInnerLength",0,"Expression",0],[1,"RearInnerOffset",0,"Expression",0],[1,"RearOuterOffset",0,"Expression",0],[1,"RearSelector",0,"ScCollector",0],[0,"RequirementsControl",1,0],[0,"ShowClearance",1,0],[0,"Standard",1,0],[0,"Visualization",1,0],[0,"WheelSize",1,0]],[],[]];
SPLM.Features.VehicleDesign.DynamicCurbBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.DynamicCurbBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.DynamicCurbBuilder.RequirementsControlType = Object.freeze({
    "StandardDriven" : "StandardDriven", "UserDefined" : "UserDefined"});

SPLM.Features.VehicleDesign.DynamicCurbBuilder.WheelType = Object.freeze({
    "StaticRadius" : "StaticRadius", "Diameter" : "Diameter"});

SPLM.Features.VehicleDesign.DynamicCurbBuilder.PositionType = Object.freeze({
    "Front" : "Front", "Rear" : "Rear", "Both" : "Both"});

SPLM.Features.VehicleDesign.DynamicCurbBuilder.MethodType = Object.freeze({
    "Horizontal" : "Horizontal", "VerticalTangent" : "VerticalTangent", "ParallelTangent" : "ParallelTangent"});

SPLM.Features.VehicleDesign.DynamicCurbBuilder.VisualizationType = Object.freeze({
    "Curve" : "Curve", "Surface" : "Surface", "CurveSurface" : "CurveSurface"});

export default SPLM;